import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Infobox } from 'ui-library';
import { PRODUCTS } from 'constants/constants';
import {
    BUTTON_TYPE_PRIMARY,
} from 'ui-library/components/Button/constants';

import './ChangeVBorVBPPlanModalContent.css';
import { NavigateFunction } from 'react-router-dom';

export const Change3aor3apPlanModalContent = ({
    path,
    is3a = false,
    is3ap = false,
    navigate,
    onNavigate = () => {},
} : {
    path: string;
    is3a: boolean;
    is3ap: boolean;
    navigate: NavigateFunction,
    onNavigate: () => void,
}) => {
    const { t } = useTranslation();
    const onChange = useCallback((productKey: string) => {
        navigate(path, { state: { productKey } });
        onNavigate();
    }, [path, navigate, onNavigate]);

    return (
        <>
            <div className="ChangeVBorVBPPlanModalContent_desc">{t('clientDashboard.change3aPlan.desc')}</div>
            <div className="ChangeVBorVBPPlanModalContent_buttonGroup">
                <Button type={BUTTON_TYPE_PRIMARY} disabled={!is3a} onClick={() => onChange(PRODUCTS.aaa)}>{t('clientDashboard.change3aPlan.3a.button')}</Button>
                <Button type={BUTTON_TYPE_PRIMARY} disabled={!is3ap} onClick={() => onChange(PRODUCTS.aaap)}>{t('clientDashboard.change3apPlan.3ap.button')}</Button>
            </div>
            <Infobox className="ChangeVBorVBPPlanModalContent_infoNote">{t('clientDashboard.change3aPlan.note')}</Infobox>
        </>
    );
};
